module.exports = __webpack_public_path__ + "img/DealerIcons-Twitter-On.c96683e.jpg";